<template>
  <div>
    <breadcrumb :items="breadcrumbs"></breadcrumb>
    <v-container fluid class="pb-10">
      <v-card flat>
        <v-toolbar flat>
          <v-toolbar-title>Animal Details</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn @click="$router.go(-1)" outlined color="primary"> Back</v-btn>
        </v-toolbar>
        <v-card-text class="px-6">
          <v-row
            class="expansion-header d-flex justify-space-between align-center px-2 black--text"
          >
            <div>{{ animalIdentification.international_id }}</div>
            <div class="font-weight-bold">{{ animalIdentification.breed }}</div>
            <div>Purebred Black Hereford 88%</div>
          </v-row>
          <v-row class="mt-5">
            <v-col lg="3" md="3" sm="12" xs="12" class="pa-0">
              <v-img class="pa-2" :src="animalImage" :lazy-src="animalImage">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="grey lighten-5"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-col>
            <v-col lg="9" md="9" sm="12" xs="12">
              <div class="d-flex justify-space-between">
                <div>
                  <div class="pl-4 font-weight-bold black--text">
                    Identification
                  </div>
                  <v-row no-gutters>
                    <v-col cols="4">
                      <v-list>
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-subtitle>Sex</v-list-item-subtitle>
                            <v-list-item-title
                              class="font-weight-bold text-capitalize"
                              >{{
                                animalIdentification.gender
                              }}</v-list-item-title
                            >
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-col>
                    <v-col cols="4">
                      <v-list>
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-subtitle
                              >Animal ID</v-list-item-subtitle
                            >
                            <v-list-item-title
                              class="font-weight-bold text-wrap"
                              >{{
                                animalIdentification.animalNumber
                              }}</v-list-item-title
                            >
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-col>
                    <v-col cols="4">
                      <v-list>
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-subtitle>Tattoo</v-list-item-subtitle>
                            <v-list-item-title class="font-weight-bold">{{
                              animalIdentification.tattoo
                            }}</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-col>
                    <v-col cols="4">
                      <v-list>
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-subtitle>Name</v-list-item-subtitle>
                            <v-list-item-title
                              class="font-weight-bold text-capitalize text-wrap"
                              >{{
                                animalIdentification.name
                              }}</v-list-item-title
                            >
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-col>
                    <v-col cols="4">
                      <v-list>
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-subtitle
                              >International ID</v-list-item-subtitle
                            >
                            <v-list-item-title class="font-weight-bold">{{
                              animalIdentification.international_id
                            }}</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-col>
                    <v-col cols="4">
                      <v-list>
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-subtitle
                              >Horn/Poll/Scur</v-list-item-subtitle
                            >
                            <v-list-item-title
                              class="font-weight-bold text-capitalize"
                              >{{
                                animalIdentification.horn
                              }}</v-list-item-title
                            >
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-col>
                    <v-col cols="4">
                      <v-list>
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-subtitle>Color</v-list-item-subtitle>
                            <v-list-item-title class="font-weight-bold">{{
                              animalIdentification.color || "-"
                            }}</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-col>
                    <v-col cols="4">
                      <v-list>
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-subtitle>Tag #</v-list-item-subtitle>
                            <v-list-item-title
                              class="font-weight-bold text-wrap"
                              >{{
                                animalIdentification?.tagNumber || "-"
                              }}</v-list-item-title
                            >
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-col>
                  </v-row>
                </div>
                <div><v-divider vertical></v-divider></div>
                <div>
                  <div class="pl-4 font-weight-bold black--text">
                    Other Results
                  </div>
                  <v-row no-gutters>
                    <v-col cols="6">
                      <v-list>
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-subtitle>Owner</v-list-item-subtitle>
                            <v-list-item-title class="font-weight-bold"
                              ><a class="text-capitalize" href="">{{
                                animalIdentification.owner || "-"
                              }}</a></v-list-item-title
                            >
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-col>
                    <v-col cols="6">
                      <v-list>
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-subtitle>Breeder</v-list-item-subtitle>
                            <v-list-item-title
                              class="font-weight-bold text-capitalize"
                            >
                              {{
                                animalIdentification.breed || "-"
                              }}</v-list-item-title
                            >
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-col>
                    <v-col cols="6">
                      <v-list>
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-subtitle>Sire</v-list-item-subtitle>
                            <v-list-item-title
                              class="font-weight-bold text-capitalize text-wrap"
                            >
                              <span v-if="animalIdentification.sire_id"
                                >{<a
                                  @click="
                                    $router.push({
                                      name: 'AnimalDetails',
                                      params: {
                                        animal_number:
                                          animalIdentification.sire_id,
                                      },
                                    })
                                  "
                                  >{{ animalIdentification.sire_id || "-" }}</a
                                >}
                                {{ animalIdentification.sire_id || "-" }}</span
                              >
                              <span v-else>-</span>
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-col>
                    <v-col cols="6">
                      <v-list>
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-subtitle>Dam</v-list-item-subtitle>
                            <v-list-item-title
                              class="font-weight-bold text-capitalize text-wrap"
                            >
                              <span v-if="animalIdentification.dam_id"
                                >{<a
                                  @click="
                                    $router.push({
                                      name: 'AnimalDetails',
                                      params: {
                                        animal_number:
                                          animalIdentification.dam_id,
                                      },
                                    })
                                  "
                                  >{{ animalIdentification.dam_id || "-" }}</a
                                >}
                                {{ animalIdentification.dam_id || "-" }}</span
                              >
                              <span v-else>-</span>
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-col>
                    <v-col cols="6">
                      <v-list>
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-subtitle
                              >Conception Method</v-list-item-subtitle
                            >
                            <span v-if="animalIdentification.conceptionMethod">
                              {{
                                animalIdentification.conceptionMethod || "-"
                              }}</span
                            >
                            <span v-else>-</span>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-col>
                    <v-col cols="6">
                      <v-list>
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-subtitle
                              >Date of Birth</v-list-item-subtitle
                            >
                            <v-list-item-title class="font-weight-bold">{{
                              animalIdentification.birthDate || "-"
                            }}</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-col>
                  </v-row>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card class="mt-5" flat>
        <v-tabs v-model="tab">
          <v-tab v-for="item in tabs" :key="item" class="text-capitalize">
            {{ item }}
          </v-tab>
        </v-tabs>
      </v-card>
      <v-card class="mt-5" flat>
        <v-card-text>
          <v-tabs-items v-model="tab">
            <v-tab-item> <EPDs /> </v-tab-item>
            <v-tab-item> <Pedigree  v-bind:epdId="epdId"/> </v-tab-item>
            <v-tab-item><Progeny v-bind:epdId="epdId" /> </v-tab-item>
            <v-tab-item> <Performance  v-bind:epdId="epdId"/> </v-tab-item>
            <v-tab-item> <OwnerDetails  v-bind:epdId="epdId"/> </v-tab-item>
          </v-tabs-items>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import EPDs from "./single-epd/EPDs.vue";
import Progeny from "./single-epd/Progeny.vue";
import OwnerDetails from "./single-epd/OwnerDetails.vue";
import Performance from "./single-epd/Performance.vue";
import Pedigree from "./single-epd/Pedigree.vue";
import AnimalService from "@/_services/AnimalService";
import loadingMixin from "@/mixins/LoadingMixin";

export default {
  components: {
    EPDs,
    Progeny,
    OwnerDetails,
    Performance,
    Pedigree,
  },

  async mounted() {
    this.startLoading();
    const animals = await AnimalService.singleAnimalDetail(
      this.$route.params.geneticid
    );

    if (animals?.data) {
      const animalResponse = animals?.data?.getByAnimalNumber;
      this.animalIdentification = animalResponse || {};
      // this.stopLoading();
      this.epdId = animalResponse?.id;
      this.loading = false;
    } else if (animals?.errors) {
      this.loading = false;

      console.log(animals?.errors);
    }
    this.stopLoading();
  },

  data() {
    return {
      epdId: null,
      tab: 0,
      tabs: ["EPDs", "Pedigree", "Progeny", "Performance", "Owner Detail"],
      animalIdentification: {},
      animalImage: "/img/no_img.png",
      conceptionMethod: [
        { text: "Natural Mating", value: "1" },
        { text: "Artificial Insemination", value: "2" },
        { text: "Embryo Transfer", value: "3" },
      ],
      breadcrumbs: [
        {
          text: this.$t("dashboard"),
          disabled: false,
          to: "/",
        },
        {
          text: this.$t("Edit Genetics"),
          disabled: true,
          to: { name: "Genetics" },
        },
      ],
    };
  },
  mixins: [loadingMixin],
};
</script>
<style scoped>
.expansion-header {
  border: 1px solid #ffb443 !important;
  background-color: #fff7ec !important;
  min-height: 60px;
  border-radius: 5px;
}

.label {
  margin-bottom: 20px !important;
}
</style>
